import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import Contents from "../components/pages/notice/en/Contents";
import { useParams } from "react-router-dom";

const Notice = () => {
    return (
        <>
            <Header />
            <Contents noticeKind={useParams().kind}/>
            <Footer />
        </>
    );
}

export default Notice;